import { AppLayout } from '@/components/layout/AppLayout';
import { PageHeader } from '@/components/layout/PageHeader';
import { IntegrationsSection } from '@/components/settings/IntegrationsSection';
import { NotificationsSection } from '@/components/settings/NotificationsSection';
import { PrivacySecuritySection } from '@/components/settings/PrivacySecuritySection';
import { DataManagementSection } from '@/components/settings/DataManagementSection';
import { LanguageSection } from '@/components/settings/LanguageSection';

export default function Settings() {
  return (
    <AppLayout>
      <div className="space-y-8 max-w-4xl">
        <PageHeader
          title="Settings"
          subtitle="Preferences, integrations & account"
          statusLabel="CONFIG: ACTIVE"
        />

        {/* Language */}
        <LanguageSection />

        {/* Notifications */}
        <NotificationsSection />

        {/* Integrations */}
        <IntegrationsSection />

        {/* Privacy & Security */}
        <PrivacySecuritySection />

        {/* Data Management */}
        <DataManagementSection />
      </div>
    </AppLayout>
  );
}
